<template>
  <section class="preview">
    <form novalidate @submit.prevent="editar">
      <mdb-input
        placeholder="Nombre Completo"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      ></mdb-input>
      <mdb-input
        placeholder="Poncentaje"
        class="mb-3 text-align-rigth"
        v-model="porcentaje"
        type="number"
        :min="porcentaje"
        required
        invalidFeedback="Coloca el porcentaje"
      >
        <span class="input-group-text md-addon" slot="append">%</span>
      </mdb-input>
      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Editar</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner
  },
  props: {
    onClick: Function,
    offert: Object
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      porcentaje: 1
    };
  },
  mounted() {
    this.name = this.offert.name;
    this.porcentaje = Number(this.offert.porcentaje);
  },
  methods: {
    editar(event) {
      event.target.classList.add("was-validated");
      var { name, porcentaje } = this;
      this.isLoading = true;
      if (name == "") {
        this.isLoading = false;
      } else {
        var offert = {
          name,
          porcentaje,
          id: Math.random()
        };
        store.dispatch("editOffert", offert).then(() => {
          this.onClick("offert");
          this.isLoading = false;
        });
      }
    }
  }
};
</script>

<style scoped>
</style>